import { ProductDocsWidget } from '../../widgets/ProductDocsWidget';
import * as React from 'react';
import { CrumbWidget } from '../../widgets/CrumbWidget';
import { ContentWidget } from '../../widgets/ContentWidget';
import { PageWidget } from '../../widgets/layout/PageWidget';
import { SectionWidget } from '../../widgets/layout/SectionWidget';
import { ReactorBlurbWidget } from '../_shared/ReactorBlurbWidget';

const override = require('../../../media/override.png');
const image_multiple_orgs = require('../../../media/stack/multiple-orgs.png');
const image_custom_policies = require('../../../media/stack/custom-policies.png');

export const OverridePage: React.FC = () => {
  return (
    <PageWidget width={1100} title="OVERRIDE">
      <ContentWidget>
        <h1>
          <CrumbWidget parts={['Platform stack', 'OVERRIDE']} />
        </h1>
        <p>
          OVERRIDE is the administration workspace for JourneyApps Platform. Create projects, manage your team's access,
          and connect source-control providers. Configure authentication and single sign-on for the people using your
          applications.
        </p>
        <p>
          Manage one organization or work across several, with separate projects and access rules for each. Custom roles
          and policies let you control who can develop, deploy, and administer resources as your team grows.
        </p>
        <img src={override} />
        <SectionWidget
          image={image_multiple_orgs}
          label={'Manage multiple organizations'}
          content="For integration partners and customers operating as a development studio, OVERRIDE allows administrators to administer
          multiple organizations at the same time, while also getting a broad overview of all their customers."
          index={1}
        ></SectionWidget>
        <SectionWidget
          image={image_custom_policies}
          ltr={false}
          label={'Write custom policies'}
          content="With OVERRIDE, administrators can write fine-grained custom policies for developers and their users, similarly to the world's largest cloud providers."
          index={2}
        ></SectionWidget>
        <ReactorBlurbWidget name="OVERRIDE" />
      </ContentWidget>
      <ProductDocsWidget
        title="Manage access with OVERRIDE"
        description="Set up authentication, manage app users, and define permissions for your organization."
        topics={['OVERRIDE']}
      />
    </PageWidget>
  );
};
